import Peps from './Peps.js';

new Peps();
